import ConverterPage from "./pages/ConverterPage";

function App() {
  return <ConverterPage />;
}

export default App;
